"use client";

import type * as React from "react";

import { useState } from "react";

import type { ButtonProps } from "./Button";
import { Button } from "./Button";
import { Dialog, DialogContent, DialogTrigger } from "./Dialog";

type DialogContentRenderer = (args: { closeDialog: () => void }) => React.ReactNode;

export interface DialogActionButtonProps {
  label: string;
  children: React.ReactNode | DialogContentRenderer;
  buttonVariant?: ButtonProps["variant"];
  buttonSize?: ButtonProps["size"];
  buttonClassName?: string;
  contentClassName?: string;
  closeButtonVariant?: "inside" | "outside";
  closeOnBackdropClick?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
  onTriggerClick?: () => void;
}

export function DialogActionButton({
  label,
  children,
  buttonVariant = "primary",
  buttonSize = "lg",
  buttonClassName,
  contentClassName,
  closeButtonVariant = "outside",
  closeOnBackdropClick = true,
  onOpenChange,
  onTriggerClick,
}: DialogActionButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  const closeDialog = () => setIsOpen(false);

  const handleOpenChange = (nextOpen: boolean) => {
    setIsOpen(nextOpen);
    onOpenChange?.(nextOpen);
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>
        <Button className={buttonClassName} onClick={onTriggerClick} size={buttonSize} variant={buttonVariant}>
          {label}
        </Button>
      </DialogTrigger>
      <DialogContent
        className={contentClassName}
        closeButtonVariant={closeButtonVariant}
        onInteractOutside={event => {
          if (!closeOnBackdropClick) {
            event.preventDefault();
          }
        }}
      >
        {typeof children === "function" ? children({ closeDialog }) : children}
      </DialogContent>
    </Dialog>
  );
}
